export enum FunnelType {
  FastTrack = 'fastTrack',
  SuperFastTrack = 'superFastTrack',
}
